enum ResponseCode {
  SUCCESS = 200,
  UNAUTHORIZED = 401,
  UNKNOWN = 999,
  FAILED_LOGIN_RESPONSE = 3001,
}

export default ResponseCode;
